import $ from 'jquery'
import { closeModal, convertDateToDdMmYyyy } from '@/function/function.js';
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import ControleEspeces from '@/components/caisse/controle-especes'

Vue.use(VueHtml2pdf)

export default {
    name: 'caisse-ouverture',
    components: {
        ControleEspeces
    },
    props: [],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            loading: false,
            d_solde_cloture: 0, //  Dernier solde de cloture representant le solde théorique à une date t
            montant_total: 0, //  Montant controllé (converti en devise principale)
            erreur_caisse: 0,
            date_ouverture: '',
        }
    },
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole(){
            return this.$store.getters['activeRole'];
        },

        /**
         * Recupère le dernier solde de cloture de la caisse en instance 
         * d'être ouverte
         * @returns 
         */
        dernier_solde_cloture() {
            return this.$store.getters['dernier_solde_cloture', this.compte_id];
        },
    },
    mounted() {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if(this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1      //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4      //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3      //  Comptabilité
            }
        }

        console.log("COMPTE OUVERTURE: ",this.compte_id, " --> ",this.activeRole.nom)

        // >>>> Dernier solde de cloture d'une caisse
        this.$store.dispatch('getDernierSoldeCloture', this.compte_id).then((response) => {
            this.d_solde_cloture = response;
            this.date_ouverture = convertDateToDdMmYyyy.convertDate(new Date());
        });
    },
    methods: {
        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        /**
         * Mis à jour à chaque changement de comptage dans le composant controle-especes
         * (montant déjà converti en devise principale si l'établissement gère deux devises)
         * @param {*} total
         */
        onTotalChange(total) {
            this.montant_total = total;
            this.calcErreurCaisse();
        },

        calcErreurCaisse()
        {
            console.log("ERREUR CAISSE: ",this.montant_total," - ",this.d_solde_cloture)
            this.erreur_caisse = this.montant_total - this.d_solde_cloture;
        },

        async ouvrirCaisse() {
            $('.err-role').fadeOut(500)
            this.loading = true;
            let err = 0
            let data = [],
                controle_billet = []

            // RECAP CONTROLE DES BILLETS & PIECES
            this.$refs.controle.getDetailLines().forEach((ligne) => {
                let contorle = ligne.prefix + '-' + ligne.nb + '-' + ligne.valeur + (ligne.role ? ('-' + ligne.role) : '')

                controle_billet.push(
                    contorle
                )
            })
            this.erreur_caisse = this.montant_total - this.d_solde_cloture;

            let commentaire = $('#txtArea').html();

            data.push({
                "compte_id": this.compte_id,
                "user_id": this.user_id,
                "date_ouverture": Date(),
                "commentaire": commentaire,
                "solde_ouverture": this.montant_total,
                "erreur_caisse": this.erreur_caisse,
                "controle_ouverture": controle_billet
            })

            if (this.compte_id == 0) {
                err++
                this.loading = false;
                $('.err-role').fadeIn(500)
            }

            if (err == 0) {
                this.$store.dispatch('openCaisse', data).then(
                    (response) => {
                        if (response == -2) {
                            // Caisse non ouvrable
                            this.loading = false;
                            $('.err-ouverture').fadeIn()
                        } else {
                            this.loading = false;
                            $('.modal').modal('hide')
                            this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
                        }

                    }
                ).catch(
                    error => {
                        this.loading = false;
                        console.log(error);
                    }

                )
            }
        },

        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        /**
         * Imprimer le rapport de versement
         */
        printRapport() {
            this.$refs.html2Pdf.generatePdf()
        },
    }
}